import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/nk/Layout";
import Home from "@/pages/Home";
import CollectionsPage from "@/pages/CollectionsPage";
import AboutPage from "@/pages/AboutPage";
import ProcessPage from "@/pages/ProcessPage";
import ContactPage from "@/pages/ContactPage";
import PamphletPage from "@/pages/PamphletPage";
import BrochurePage from "@/pages/BrochurePage";
import BusinessCardPage from "@/pages/BusinessCardPage";
import AlterationsPage from "@/pages/AlterationsPage";
import AlterationsBrochurePage from "@/pages/AlterationsBrochurePage";
import AlterationsPamphletPage from "@/pages/AlterationsPamphletPage";
import PrintPackPage from "@/pages/PrintPackPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/pamphlet" element={<PamphletPage />} />
        <Route path="/brochure" element={<BrochurePage />} />
        <Route path="/alterations-brochure" element={<AlterationsBrochurePage />} />
        <Route path="/alterations-pamphlet" element={<AlterationsPamphletPage />} />
        <Route path="/business-card" element={<BusinessCardPage />} />
        <Route path="/print-pack" element={<PrintPackPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/collections" element={<CollectionsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/alterations" element={<AlterationsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
